
import { defineComponent, PropType } from "vue";
import Thumbnail, { ThumbnailItem } from "@/components/Thumbnail.vue";
import { ITemplateSet } from "@/services/Models";
import { toResourceUrl } from "@/lib/shared";

export default defineComponent({
  name: "TemplateThumbnailSelectFrame",
  components: {
    Thumbnail,
  },
  props: {
    item: { require: true, type: Object as PropType<ITemplateSet> },
  },
  setup(props, context) {
    const selectTemplate = () => {
      context.emit("done", props.item?.id);
    };
    const thumbnailItem = new ThumbnailItem({
      imgPath: toResourceUrl(props.item?.thumbnail ?? ""),
      clickAction: selectTemplate,
    });

    return {
      selectTemplate,
      thumbnailItem,
    };
  },
});
